import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ProgressCircleIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { opacity: "0.2", d: "M8 16C3.58887 16 0 12.4111 0 8C0 3.58887 3.58887 0 8 0C12.4111 0 16 3.58887 16 8C16 12.4111 12.4111 16 8 16ZM8 3C5.24316 3 3 5.24316 3 8C3 10.7568 5.24316 13 8 13C10.7568 13 13 10.7568 13 8C13 5.24316 10.7568 3 8 3Z" }),
        React.createElement("path", { d: "M13.2907 13.2849L11.8718 11.868C11.684 11.6804 11.6867 11.3878 11.856 11.1835C12.5969 10.2893 13 9.17554 13 8.00001C13 5.4034 11.01 3.26249 8.47514 3.0224C8.21002 2.99729 8 2.79101 8 2.5247V0.523044C8.00001 0.238074 8.23984 -0.00148619 8.52422 0.0169938C12.692 0.287874 16 3.76498 16 8.00001C16 9.95966 15.2997 11.8127 14.0177 13.2722C13.8299 13.486 13.4921 13.486 13.2907 13.2849Z" })));
};

export { ProgressCircleIcon };
//# sourceMappingURL=ProgressCircleIcon.esm.js.map
